<template>
  <div style="width: 100%;">
    <xr-table ref="xrTable" :configure="configure"></xr-table>
  </div>
</template>

<script>
  import  XrTable from '../../../XrTable/simple'

  export default {
    name: "pageSelectRoleMultiple",
    data (){
      return {
        configure: {
          url: '/web/service?method=tCoreRole_list',
          isShowSearch: false,
          defaultNoLoadData: true,
          isSelectFirst: true,
          pagination: false,
          idField: 'id',
          columns: [
            {
              field: 'ck',
              width: 60,
            },
            {
              field: 'roleName',
              title: '角色名称',
              width: 200,
              condition: {
                searchType: 'input',
                searchName: 'roleNameSearch',
                value:''
              },
            },
            {
              field: 'roleDesc',
              title: '描述',
              width: 200,
              condition: {
                searchType: 'input',
                searchName: 'roleDescSearch',
                value:''
              },
            }
          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            }
          ]
        },
      }
    },
    components: {
      XrTable
    },
    methods: {
      init() {
        this.$refs.xrTable.getData();
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let valueList = this.$refs.xrTable.multipleSelection;
        let list = this.$refs.xrTable.multipleSelectionItem;
        let selectValues = '';
        let selectLabels = '';
        for(let i = 0;i < valueList.length;i++){
          selectValues = selectValues + valueList[i] + ",";
          selectLabels = selectLabels + list[i].roleName + ",";
        }
        selectValues = selectValues.substring(0,selectValues.length-1);
        selectLabels = selectLabels.substring(0,selectLabels.length-1);


        if(!selectValues){
          alert('请选择！');
          return false;
        }
        this.$emit('confirmMethod',selectValues,selectLabels);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/role/roleMultiplePageSelect.vue